<template>
    <div class="novel_review_box">
        <common-top :commonTopData="commonTopData"></common-top>
        <el-row class="p-operation">
            <el-col :span="12">
                <el-tabs class="p-tabs" v-model="checkStatus" @tab-click="tabHandleClick">
                    <el-tab-pane label="待审核" name="0"></el-tab-pane>
                    <el-tab-pane label="审核通过" name="1"></el-tab-pane>
                    <el-tab-pane label="不通过" name="-1"></el-tab-pane>
                    <el-tab-pane label="全部记录" name="3"></el-tab-pane>
                </el-tabs>
            </el-col>
            <el-col :span="12" class="p-right-operation-btn">
                <el-button class="p-fitler-btn" type="text" size="mini" @click="is_NovelDrawer = true">
                    <img src="~@/assets/img/icon_sx.svg">筛选
                </el-button>
            </el-col>
        </el-row>
        <div class="p-table-wrap">
        <CommonNovelTable :type_name="'look'" :tableTitle="tableTitle" :tableData="tableData.data" :btnList="btnList"/>
        </div>
        <div>
            <CommonNovelPagination :data_obj="tableData" :page="page" :limit="limit" @set_page="set_page" @set_limit="set_limit"/>
        </div>
        <!-- 筛选 -->
        <NovelDrawer ref="rawer" @reset="reset" :drawer="is_NovelDrawer" :direction="direction" :rawer_list="checkStatus!='3'?rawer_list:rawer_list_all" @screen="screen" @handleClose_drawer="handleClose_drawer"/>
        <el-dialog
        title="提示"
        :visible.sync="edit_dialogVisible"
        width="50%"
        :close-on-click-modal="false"
        :before-close="edit_handleClose">
        <div class="edit_dialogVisible_box">
            <div>
                {{edit_data.lable}}
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="edit_handleClose">取 消</el-button>
            <el-button type="primary" @click="edit_confirm">确 定</el-button>
        </span>
        </el-dialog>

        <!-- <el-drawer
        size="800px"
        title="详情"
        :visible.sync="drawer"
        :direction="direction"
        :before-close="handleClose">
        <div class="drawer_box">
            <div class="ai_check_box" v-if="ai_check_data.total">
                <ul class="ai_check_ul" v-for="(val,index) in ai_check_data.data" :key="index">
                    <li class="ai_check_li">
                        <div class="ai_check_li_left">类型：</div>
                        <div class="ai_check_li_right">{{val.type=='text'?'文本':'图片'}}</div>
                    </li>
                    <li class="ai_check_li">
                        <div class="ai_check_li_left">被审核内容：</div>
                        <div class="ai_check_li_right" v-if="val.type=='text'" v-html="val.content"></div>
                        <div class="ai_check_li_right" v-else>
                            <el-image 
                                style="width: 200px"
                                :src="val.content" 
                                :preview-src-list="[val.content]">
                            </el-image>
                        </div>
                    </li>
                    <li class="ai_check_li">
                        <div class="ai_check_li_left">AI审核平台：</div>
                        <div class="ai_check_li_right">{{val.check_platform=='baidu'?'百度':'阿里'}}</div>
                    </li>
                    <li class="ai_check_li">
                        <div class="ai_check_li_left">审核结果：</div>
                        <div class="ai_check_li_right" :style="{color:set_status_color(val.check_result_type)}">{{set_status(val.check_result_type)}}</div>
                    </li>
                    <li class="ai_check_li">
                        <div class="ai_check_li_left">审核结果描述：</div>
                        <div class="ai_check_li_right">{{val.check_summary||'--'}}</div>
                    </li>
                    <li class="ai_check_li">
                        <div class="ai_check_li_left">审核关联关键字：</div>
                        <div class="ai_check_li_right">{{val.check_result_words||'--'}}</div>
                    </li>
                    <li class="ai_check_li">
                        <div class="ai_check_li_left">审核时间：</div>
                        <div class="ai_check_li_right">{{val.update_at||'--'}}</div>
                    </li>
                </ul>
            </div>
            <div v-else class="no_data_box">
                <div>无数据...</div>
            </div>
        </div>
        <div class="details_btn_box" v-if="checkStatus=='1'">
            <el-button type="primary" @click="details_click('1')">通过</el-button>
            <el-button type="danger" @click="details_click('-1')">不通过</el-button>
        </div>
        </el-drawer> -->
    </div>
</template>

<script>
import axios from 'axios'
import NovelDrawer from '@/components/novel_drawer/novel_drawer.vue'
import CommonNovelPagination from '@/components/common_novel_pagination/common_novel_pagination.vue'
import commonTop from '@/components/commonTop.vue'
import CommonNovelTable from '@/components/common_novel_table/common_novel_table.vue'
export default {
    components:{
        commonTop,
        CommonNovelTable,
        NovelDrawer,
        CommonNovelPagination
    },
    data(){
        return{
            checkStatus:'0',
            btns:[
                {label:'专题列表',value:'comZt'},
                {label:'内容管理',value:'comNr'},
            ],
            onNav:1,
            drawer: false,
            direction: 'rtl',
            edit_dialogVisible:false,
            fun_callback_data:{},
            edit_data:{},
            nove_baseURLS:'',
            direction:'rtl',//筛选框打开的方向
            is_NovelDrawer:false,
            commonTopData: {
				"commonleftbtn": [],
			},
            tableData:{},
            tableTitle:[
                {label:'渠道',prop:'channel'},
                {label:'心愿ID',prop:'message_id'},
                {label:'用户ID',prop:'user_id'},
                {label:'心愿内容',prop:'content'},
                {label:'发布地址',prop:'city',is_stringify:true},
                {label:'状态',prop:'status',
                    turn_fun:(val)=>{
                        switch(val) {
                            case '0':
                                return '待审核'
                            case '1':
                                return '审核通过'
                            case '-1':
                                return '审核不通过'
                            default:
                                // 默认代码块
                                return val
                        } 
                    },
                    text_color_name:'status',
                    text_color:(val)=>{
                        switch(val) {
                            case '0':
                                return '#33B3FF'
                            case '1':
                                return '#65bc20'
                            case '-1':
                                return '#f55553'
                            default:
                                // 默认代码块
                                return val
                        } 
                    }
                },
                {label:'发布时间',prop:'create_at'},
                {label:'用户昵称',prop:'username'},
                {label:'用户头像',prop:'avatar',width:100,is_img:true},
            ], 
            custom_list:[

            ],
            rawer_list:[
                {label:'心愿ID',prop:'message_id',placeholder:"请输入心愿ID检索",},
            ],
            rawer_list_all:[
                {label:'心愿ID',prop:'message_id',placeholder:"请输入心愿ID检索",},
                // {label:'用户ID',prop:'user_id',placeholder:"请输入用户ID检索",},
                // {label:'用户昵称',prop:'username',placeholder:"请输入用户昵称检索",},
                {label:'状态',prop:'status',
                status_list:[
                        {
                            value: '0',
                            label: '待审核'
                        }, {
                            value: '1',
                            label: '审核通过'
                        },
                        {
                            value: '-1',
                            label: '不通过'
                        },
                    ],status:'',placeholder:"请选择状态检索"
                }
            ],
            btnList:[
                {
                    btn:'审核通过',
                    btn_type:'text',
                    is_show_fun:(val)=>{
                        if(this.checkStatus == '0' || (this.checkStatus == '3' && val=='0')){
                            return true
                        }
                        return false
                    },
                    fun:(val)=>{
                        console.log(val)
                        this.fun_callback_data={
                            message_id:val.message_id,
                            status:'1',
                            key: '8f62cd3227ffafaa3f10016f46c41a6b'
                        }
                        this.edit_data = {
                            lable:'确定审核通过吗？',
                        }
                        this.edit_dialogVisible = true
                    },
                },
                {
                    btn:'审核不通过',
                    btn_type:'text',
                    is_show_fun:(val)=>{
                        if(this.checkStatus == '0' || (this.checkStatus == '3' && val=='0')){
                            return true
                        }
                        return false
                    },
                    fun:(val)=>{
                        console.log(val)
                        this.fun_callback_data={
                            message_id:val.message_id,
                            status:'-1',
                            key: '8f62cd3227ffafaa3f10016f46c41a6b'
                        }
                        this.edit_data = {
                            lable:'确定审核不通过吗？',
                        }
                        this.edit_dialogVisible = true
                    },
                },
            ],
            page:1,
            limit:10,
            ids:{},
            ai_check_data:[],
            baseURL:window.location.host == 'shiquaner-admin.zookingsoft.com'?'https://xz-api.baizlink.top/':'http://139.129.221.123:8043/',
        
            /////
        }
    },
    mounted(){
        this.get_green_contentCheckList()
    },
    methods:{
        //获取心愿列表接口
        get_green_contentCheckList(){
            axios.get(this.baseURL+"api/usermessage/list",{
            params:{
                page:this.page,
                limit:this.limit,
                status:this.checkStatus=='3'?'':this.checkStatus,
                ...this.screen_params
            }
            }).then((res)=>{
                this.tableData = res.data.data
            })
        },
        //tab切换
        tabHandleClick(){
            this.page = 1
            this.limit = 10
            this.screen_params = {}
            this.$refs.rawer.chongZhi()
            this.get_green_contentCheckList()
        },
        //审核通过
        edit_confirm(){
            let params = {
                ...this.fun_callback_data,
            }
            axios.get(this.baseURL+"api/usermessage/adminCheck",{
                params
            }).then((res)=>{
                this.edit_dialogVisible = false
                this.$message({
                    type:'success',
                    message:'操作成功',
                    offset:65,
                })
                this.get_green_contentCheckList()
                this.$forceUpdate()
            }).catch((error)=> {
                this.$message({
                    type:'error',
                    message:'操作失败',
                    offset:65,
                })
            })
        },
        set_limit(val){
            this.page = 1
            this.limit = val
        },

        set_page(val){
            this.page = val
            this.get_green_contentCheckList()
        },
        //筛选
        screen(val){
            this.is_NovelDrawer = false
            this.page = 1
            this.limit = 10
            let params = {
                ...val
            }
            this.screen_params = JSON.parse(JSON.stringify(params))
            console.log(params,'筛选事件')
            this.get_green_contentCheckList()
        },



        ////////////////////////
        set_status(val){
            switch(val) {
                case '1':
                    return '通过'
                case '2':
                    return '不通过'
                case '3':
                    return '疑似'
                case '4':
                    return '审核失败'
                default:
                    // 默认代码块
                    return val
            } 
        },
        set_status_color(val){
            switch(val) {
                case '1':
                    return '#67C239'
                case '2':
                    return '#f55553'
                case '3':
                    return '#d9c92f'
                case '4':
                    return '#d92fc6'
                default:
                    // 默认代码块
                    return val
            } 
        },
        get_green_contentList(){
            let params = {
                page:this.page,
                limit:this.limit,
                ...this.screen_params
            }
            this.api.green_contentList(params).then(da=>{
                let tableData = JSON.parse(JSON.stringify(da));
                this.tableData = tableData
            })
        },
        details_click(status){
            this.fun_callback_data={
                id:this.ids,
                check_status:status,
            }
            this.edit_data = {
                lable:status=='1'?'确定审核通过吗？':'确定不通过？不通过的内容将被从内容库下架',
            }
            this.edit_dialogVisible = true
        },
        handleClose(){
            this.drawer = false
        },
        edit_handleClose(){
            this.edit_dialogVisible = false
        },
        reset(){
            this.screen_params = {}
        },
        get_green_detailList(val){
            let params = {
                task_id:val.task_id,
                origin_id:val.origin_id
            }
            this.api.green_detailList(params).then(da=>{
                this.ai_check_data = da
                console.log(this.ai_check_data,'green_detailList')
			})
        },
        handleClose_drawer(){
            this.is_NovelDrawer = false
        },
    }
}
</script>

<style lang="scss" scoped>
@import "styles/define";
.novel_review_box{
    height: 100%;
    overflow: hidden;
    .p-table-wrap{
        overflow-x: hidden;
        overflow-y: scroll;
        display: flex;
        flex-direction: column;
        height: calc(100% - 200px);
        background-color: white;
    }
    .ahx_box{
        display: flex;
        justify-content: flex-end;
    }
    .edit_dialogVisible_box{
        display: flex;
        flex-direction: column;
        align-items: center;
        .tips_text_box{
            color: rgb(0, 119, 255);;
        }
        .picker_box{
            margin-top: 20px;
        }
    }
    .drawer_box{
        padding: 20px;
        padding-bottom: 100px;
        .details_title{
            display: flex;
            justify-content: center;
        }
        .details_doc_box{
            display: flex;
            justify-content: space-between;
            margin: 20px 0;
        }
        .words_box{
            margin-top: 40px;
            .de{
                margin: 10px 0;
                color: #666;
                span{
                    color: rgb(100, 138, 241);
                }
            }
        }
        .result_box{
            margin-top: 30px;
            .row_box{
                margin: 20px 0;
                .lie_title{
                    font-size: 18px;
                }
                .lie{
                    display: flex;
                    margin: 5px 0;
                    color:#666;
                    .lie_doc{
                        width: 80px;
                        display: flex;
                        justify-content: flex-end;
                        margin-left: 15px;
                    }
                    .lie_tps1{
                        color:rgb(58, 187, 144)
                    }
                    .lie_tps2{
                        color:rgb(248, 64, 64)
                    }
                }
            }
        }
    }
    .details_btn_box{
        position: fixed;
        bottom: 0;
        width: 800px;
        background: #fff;
        height: 70px;
        display: flex;
        justify-content: center;
        // flex-direction: column;
        align-items: center;
        .el-button{
            height: 40px;
        }
    }
    .p-operation{
        background-color: $background-color-base;
        padding-bottom: 10px;
        .p-right-operation-btn{
            text-align: right;
            .p-fitler-btn{
                display: flex;
                justify-items: center;
                display: inline-block;
                img{
                    margin-right: 4px;
                }
            }
        }
        .el-tabs__header {
            margin: 0;
        }
        .el-tabs__nav-wrap::after {
            display: none;
        }
        .el-col {
            min-height: 1px;
        }
        .p-tabs {
            position: fixed;
            left: 50%;
            top: 8px;
            transform: translateX(-50%);
        }
    }
    .ai_check_box{
        // width: 500px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .ai_check_ul{
            width: 600px;
            display: flex;
            flex-direction: column;
            justify-items: center;
            padding: 30px;
            border: 1px solid #ccc;
            margin: 20px 0;
            box-shadow:0px 15px 10px  #999;
            .ai_check_li{
                display: flex;
                align-items: center;
                padding: 10px 0;
                .ai_check_li_left{
                    min-width: 150px;
                    margin-right: 15px;
                    display: flex;
                    justify-content: flex-end;
                }
                .ai_check_li_right{
                    img{
                        width: 200px;
                    }
                }
            }
        }
    }
    .no_data_box{
        display: flex;
        align-items: center;
        justify-content: center;
        div{
            font-size: 20px;
            color: #666;
        }
    }
}
</style>

<style lang="scss">
.novel_review_box{
    .el-tabs__nav-wrap::after {
        background: #fff;
    }
}
</style>